import request from '../request'

// MF-67 — Journal entries API (staff-created records).
export const getEntries = (params = {}) => request.get('/journal/entries', { params }).then((res) => res)

export const getEntry = (entryId = '') => request.get(`/journal/entries/${entryId}`).then((res) => res)

export const createEntry = (data = {}) => request.post('/journal/entries', data).then((res) => res)

export const updateEntry = (entryId = '', data = {}) =>
  request.put(`/journal/entries/${entryId}`, data).then((res) => res)

export const deleteEntry = (entryId = '') => request.delete(`/journal/entries/${entryId}`).then((res) => res)

// MF-67 — Append a follow-up to a case: { note, status }.
export const addFollowUp = (entryId = '', data = {}) =>
  request.post(`/journal/entries/${entryId}/follow-up`, data).then((res) => res)

// MF-67 — Delete a single follow-up event from the case timeline (by its index in events[]).
export const deleteEntryEvent = (entryId = '', index) =>
  request.delete(`/journal/entries/${entryId}/events/${index}`).then((res) => res)

// MF-67 — Aggregated insights over the list filters: { bucket, totals, byType, trend, topTemplates }.
export const getEntriesStats = (params = {}) =>
  request.get('/journal/entries/stats', { params }).then((res) => res)
